import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a61d20d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-4 p-5 align-items-center\" data-v-0a61d20d><div data-v-0a61d20d><svg width=\"43\" height=\"45\" viewBox=\"0 0 43 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-0a61d20d><rect width=\"42.4652\" height=\"45\" rx=\"10\" fill=\"#F9F9F9\" data-v-0a61d20d></rect><g clip-path=\"url(#clip0_3447_1695)\" data-v-0a61d20d><path opacity=\"0.5\" d=\"M25.2588 15H22.2435C21.9627 15 21.6924 15.1172 21.4853 15.3281L18.0348 18.8437C18.0313 18.8477 18.0278 18.8555 18.0243 18.8594C17.4416 19.4687 17.4521 20.4414 17.9506 21.0469C18.3964 21.5898 19.3336 21.7344 19.9198 21.1523C19.9233 21.1484 19.9303 21.1484 19.9338 21.1445L22.7384 18.2852C22.9666 18.0547 23.3246 18.0703 23.5317 18.3242C23.7424 18.5781 23.7248 18.9727 23.4966 19.207L22.5805 20.1406L27.6913 24.7578C27.7931 24.8516 27.8844 24.9531 27.9686 25.0586V17.5L26.0521 15.3672C25.845 15.1328 25.5571 15 25.2588 15ZM29.0954 17.5078V26.2539C29.0954 26.9453 29.5973 27.5039 30.2186 27.5039H32.4652V17.5078H29.0954ZM30.7803 26.2539C30.4714 26.2539 30.2186 25.9727 30.2186 25.6289C30.2186 25.2852 30.4714 25.0039 30.7803 25.0039C31.0892 25.0039 31.3419 25.2852 31.3419 25.6289C31.3419 25.9727 31.0892 26.2539 30.7803 26.2539ZM10 27.5H12.2465C12.8678 27.5 13.3698 26.9414 13.3698 26.25V17.5078H10V27.5ZM11.6849 25.0039C11.9938 25.0039 12.2465 25.2852 12.2465 25.6289C12.2465 25.9727 11.9938 26.2539 11.6849 26.2539C11.376 26.2539 11.1233 25.9727 11.1233 25.6289C11.1233 25.2812 11.376 25.0039 11.6849 25.0039ZM26.9858 25.7305L21.7451 20.9961L20.692 22.0703C19.6495 23.1289 18.0524 23.0273 17.1222 21.8984C16.1779 20.75 16.2516 18.9727 17.2766 17.9258L20.1479 15H17.2064C16.908 15 16.6237 15.1328 16.4131 15.3672L14.493 17.5V26.2461H15.1354L18.3121 29.4453C19.2739 30.3164 20.6885 30.1523 21.4713 29.082L21.4783 29.0742L22.1066 29.6797C22.6647 30.1875 23.4896 30.0898 23.9424 29.4687L25.0446 27.9609L25.2342 28.1328C25.7151 28.5664 26.4241 28.4883 26.8138 27.9492L27.1472 27.4922C27.5404 26.9531 27.4667 26.168 26.9858 25.7305Z\" fill=\"#203972\" data-v-0a61d20d></path><path d=\"M10 27.5H12.2465C12.8678 27.5 13.3698 26.9414 13.3698 26.25V17.5078H10V27.5ZM11.6849 25.0039C11.9938 25.0039 12.2465 25.2852 12.2465 25.6289C12.2465 25.9727 11.9938 26.2539 11.6849 26.2539C11.376 26.2539 11.1233 25.9727 11.1233 25.6289C11.1233 25.2812 11.376 25.0039 11.6849 25.0039ZM26.9858 25.7305L21.7451 20.9961L20.692 22.0703C19.6495 23.1289 18.0524 23.0273 17.1222 21.8984C16.1779 20.75 16.2516 18.9727 17.2766 17.9258L20.1479 15H17.2064C16.908 15 16.6237 15.1328 16.4131 15.3672L14.493 17.5V26.2461H15.1354L18.3121 29.4453C19.2739 30.3164 20.6885 30.1523 21.4713 29.082L21.4783 29.0742L22.1066 29.6797C22.6647 30.1875 23.4896 30.0898 23.9424 29.4687L25.0446 27.9609L25.2342 28.1328C25.7151 28.5664 26.4241 28.4883 26.8138 27.9492L27.1472 27.4922C27.5404 26.9531 27.4667 26.168 26.9858 25.7305Z\" fill=\"#203972\" data-v-0a61d20d></path></g><defs data-v-0a61d20d><clipPath id=\"clip0_3447_1695\" data-v-0a61d20d><rect width=\"22.4652\" height=\"25\" fill=\"white\" transform=\"translate(10 10)\" data-v-0a61d20d></rect></clipPath></defs></svg></div><div data-v-0a61d20d><p class=\"m-0 subtitulo cor_texto_1\" data-v-0a61d20d>Dados da implantação</p></div></div><div class=\"px-5\" data-v-0a61d20d><hr class=\"text-muted m-0\" data-v-0a61d20d></div>", 2)
const _hoisted_3 = { class: "d-flex flex-column gap-4 p-5" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-column gap-1"
}
const _hoisted_5 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Plano", -1))
const _hoisted_7 = { class: "d-flex flex-column gap-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Consultor Responsável", -1))
const _hoisted_9 = { class: "d-flex gap-2 flex-row" }
const _hoisted_10 = { class: "d-flex flex-column gap-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Checklist Entrada", -1))
const _hoisted_12 = { class: "d-flex flex-column gap-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Checklist Inspeção", -1))
const _hoisted_14 = {
  class: "d-flex gap-3 p-0",
  style: {"align-items":"end"}
}
const _hoisted_15 = { class: "d-flex flex-column gap-1 flex-grow-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Automação", -1))
const _hoisted_17 = {
  class: "d-flex",
  style: {"height":"40px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Resetar cache", -1))
const _hoisted_19 = { class: "d-flex gap-3 p-0" }
const _hoisted_20 = { class: "d-flex flex-column gap-1 w-100" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-6" }, "Previsão implantação", -1))
const _hoisted_22 = { class: "d-flex gap-3 p-0" }
const _hoisted_23 = { class: "d-flex flex-column gap-1 w-100" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Data implantação", -1))
const _hoisted_25 = { class: "d-flex gap-3 p-0" }
const _hoisted_26 = { class: "d-flex flex-column gap-1 w-100" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-6" }, "Observações gerais", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("ul", _hoisted_3, [
      (_ctx.openCreateStore.status)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(_ctx.planoSelected && _ctx.planoSelected === "99" ? "Gratuito" : ""), 1)
            ]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.planoSelected,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.planoSelected) = $event)),
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planos, (plano, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: key,
                    label: plano.nome,
                    value: plano.ordem
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(plano.nome) + " - Valor: R$ " + _toDisplayString(plano.valor), 1)
                    ]),
                    _: 2
                  }, 1032, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_select, {
            class: "col-12",
            modelValue: _ctx.implantacaoAtt.idConsultor,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.implantacaoAtt.idConsultor) = $event)),
            filterable: "",
            clearable: "",
            placeholder: "Altere o consultor",
            onChange: _ctx.dadosAtt
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.implantacao.arrayConsultor, (consultor, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: consultor.name,
                  value: consultor.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ])
      ]),
      _createElementVNode("li", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_el_select, {
          modelValue: _ctx.tipoChecklistEnt,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tipoChecklistEnt) = $event)),
          "value-key": "checklist"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "Sem checklist",
              value: 0
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.implantacao.checklistEntrada, (check, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: key,
                label: check.nome,
                value: check
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("li", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_el_select, {
          modelValue: _ctx.tipoChecklistSaida,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tipoChecklistSaida) = $event)),
          "value-key": "checklist"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "Sem checklist adicional",
              value: 0
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.implantacao.checklistInspecao, (check, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: key,
                label: check.nome,
                value: check
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("li", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_el_select, {
            modelValue: _ctx.implantacaoAtt.ErpLoja,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.implantacaoAtt.ErpLoja) = $event)),
            clearable: "",
            placeholder: "Selecione um ERP"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.implantacao.arrayErpsLoja, (erp, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: erp.nome,
                  value: erp.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_Button, {
            type: "button",
            variant: "primary",
            onClick: _ctx.resetCacheAtualizaEstoquePdv,
            title: "Resetar cache redis da rota atualiza estoque, para automação poder enviar produtos fora do período de espera de 4 horas"
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("li", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.implantacao.previsaoImplantacao,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.implantacao.previsaoImplantacao) = $event)),
                class: "w-100",
                type: "date",
                placeholder: "Selecione o mẽs",
                format: "DD/MM/YYYY",
                "default-value": [new Date()]
              }, null, 8, ["modelValue", "default-value"])
            ]),
            _: 1
          }, 8, ["locale"])
        ])
      ]),
      _createElementVNode("li", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.implantacao.dataImplantacao,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.implantacao.dataImplantacao) = $event)),
                class: "w-100",
                type: "date",
                placeholder: "Selecione o mẽs",
                format: "DD/MM/YYYY",
                "default-value": [new Date()]
              }, null, 8, ["modelValue", "default-value"])
            ]),
            _: 1
          }, 8, ["locale"])
        ])
      ]),
      _createElementVNode("li", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _withDirectives(_createElementVNode("textarea", {
            maxlength: "300",
            style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
            class: "p-2",
            placeholder: "Digite...",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.implantacao.observacoesGerais) = $event))
          }, null, 512), [
            [_vModelText, _ctx.implantacao.observacoesGerais]
          ])
        ])
      ])
    ])
  ], 64))
}